// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14yGR","type":"styles_type__oQkGc","choices":"styles_choices__26Hik"};